var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"operations_layout"}},[(_vm.is_initialized)?_c('transition',{attrs:{"name":"slide-fade","mode":"out-in","appear":""}},[_c('router-view')],1):_c('div',{staticClass:"ui active centered inline large loader"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }